// extracted by mini-css-extract-plugin
module.exports = {"faq":"ModuleFaqsFaq_faq__QZULI","opened":"ModuleFaqsFaq_opened__WkndU"};